export default __webpack_public_path__ + "static/media/Muli-Regular.1e6db0b8.ttf";